// @flow
import * as actionTypes from '../constants/action_types'

export type DigpopType = {
    visible: boolean,
    // Ascii grid definition
    grid: string,
}

type DigpopActionType = {
    grid: string,
}

const initialState = {
    visible: true,
    grid: '',
}

export default function digpop(state: DigpopType = initialState, action: DigpopActionType) {
    let newstate = state
    return newstate
}
